import * as Yup from "yup";

const schema = {
  item_name: Yup.string().required("กรุณากรอกชื่อสินค้า"),
  qty: Yup.number()
    .transform((value) =>
      isNaN(value) || value === null || value === undefined ? 0 : value
    )
    .positive("กรุณากรอกจำนวนสินค้า")
    .required("กรุณากรอกจำนวนสินค้า"),
  uom_id: Yup.string().required("กรุณาเลือกหน่วย"),
  price_per_unit: Yup.number()
    .transform((value) =>
      isNaN(value) || value === null || value === undefined ? 0 : value
    )
    .positive("กรุณากรอกจำนวนเงินที่มากกว่า 0")
    .required("กรุณากรอกราคาต่อหน่วย"),
  is_active: Yup.bool().oneOf(
    [true],
    "กรุณาระบุสินค้าใหม่ เนื่องจากมีสินค้าที่หยุดใช้งาน"
  ),
};

export const validationItemList = Yup.object().shape({
  item_list: Yup.array()
    .of(Yup.object().shape(schema))
    .min(1, "กรุณาเลือกสินค้าอย่างน้อย 1 ชิ้น"),
});

export const validationItemListCreditNote = Yup.object().shape({
  item_list: Yup.array()
    .of(Yup.object().shape(schema))
    .min(1, "กรุณาเลือกสินค้าอย่างน้อย 1 ชิ้น"),
  credit_description: Yup.string().required("กรุณาระบุประเภทการลดหนี้"),
});
